module.exports = __webpack_public_path__ + "static/media/Icons.4004fc07.svg";